import { PullTask, OS, App } from './enum'

/**
 * @description table driven implement of wiki below
 * @link http://wiki.imgo.tv/pages/viewpage.action?pageId=5280830
 */
export const envTable = [
  {
    os: OS.ios,
    app: App.weixin,
    global: false,
    pull: PullTask.pullTencent,
    bg: false,
    button: false
  },
  {
    os: OS.ios,
    app: App.weixin,
    global: true,
    pull: PullTask.noop,
    bg: true,
    button: false
  },
  {
    os: OS.android,
    app: App.weixin,
    global: false,
    pull: PullTask.pullTencent,
    bg: false,
    button: false
  },
  {
    os: OS.android,
    app: App.weixin,
    global: true,
    pull: PullTask.noop,
    bg: true,
    button: false
  },
  {
    os: OS.ios,
    app: App.normal,
    pull: [
      {
        task: PullTask.pullSchema,
        hidden: false
      },
      {
        task: PullTask.appStore,
        defer: 5000
      }
    ],
    bg: true,
    button: true
  },
  {
    os: OS.android,
    app: App.normal,
    pull: [
      {
        task: PullTask.pullSchema
      },
      {
        task: PullTask.downloadAPK,
        defer: 2000
      }
    ],
    bg: false,
    button: false
  },
  {
    os: OS.ios,
    app: App.qq,
    global: false,
    pull: PullTask.pullTencent,
    bg: false,
    button: false
  },
  {
    os: OS.ios,
    app: App.qq,
    global: true,
    pull: PullTask.noop,
    bg: true,
    button: false
  },
  {
    os: OS.android,
    app: App.qq,
    global: false,
    pull: PullTask.pullTencent,
    bg: false,
    button: false
  },
  {
    os: OS.android,
    app: App.qq,
    global: true,
    pull: PullTask.noop,
    bg: true,
    button: false
  },
  {
    app: App.weibo,
    pull: PullTask.noop,
    bg: true,
    button: false
  }
]
